import React, { useEffect, useRef } from "react";
import classNames from "classnames";

import { useDrag } from "react-use-gesture";

import "./Knob.scss";

const ROTATION_SPEED = 1 / 200;

const ROTATION_MIN = -150;
const ROTATION_MAX = 150;

interface KnobProps {
  value: number;
  min: number;
  max: number;
  step: number;
  labelImgUrl: string;
  labelText: string;
  knobImgUrl: string;
  knobBackgroundImgUrl: string;
  classNameSuffix: string;
  onChange: (newVal: number) => void;
}
export const Knob: React.FC<KnobProps> = ({
  value,
  min,
  max,
  step,
  classNameSuffix,
  labelImgUrl,
  knobImgUrl,
  knobBackgroundImgUrl,
  labelText,
  onChange,
}) => {
  let wrapperRef = useRef<HTMLDivElement>(null);
  let bindDrag = useDrag(
    ({ delta: [, y], event }) => {
      let range = max - min;
      onChange(
        Math.max(min, Math.min(max, value - y * range * ROTATION_SPEED))
      );
      event?.preventDefault();
    },
    { axis: "y", domTarget: wrapperRef, eventOptions: { passive: false } }
  );
  useEffect(bindDrag, [bindDrag]);

  let knobRotation =
    ROTATION_MIN +
    ((value - min) / (max - min)) * (ROTATION_MAX - ROTATION_MIN);

  return (
    <div className={classNames("knob", `knob--${classNameSuffix}`)}>
      <img
        className={classNames("knobLabel", `knobLabel--${classNameSuffix}`)}
        src={labelImgUrl}
        alt={labelText}
      />
      <div className="knobWrapper" ref={wrapperRef}>
        <label className="knobForeground">
          <span className="sr-only">{labelText}</span>
          <input
            className="offscreen"
            type="range"
            value={value}
            min={min}
            max={max}
            step={step}
            onChange={(evt) => onChange(+evt.target.value)}
          />
          <img
            src={knobImgUrl}
            alt={labelText}
            style={{ transform: `rotate(${knobRotation}deg)` }}
          />
        </label>
        <img
          className="knobBackground"
          src={knobBackgroundImgUrl}
          alt={labelText}
        />
      </div>
    </div>
  );
};
